"use client"

import * as React from "react"
import AuthModal from "../../components/authentication/AuthModal"
import { AnimatePresence } from "framer-motion"
import { CommonFunctionCtx } from "../../context/commonFunctionContext"
import { useAuthenticatedUser } from "../../hooks/useAuthenticatedUser"
import { useLocation, useNavigate } from "react-router-dom"
import { UserCtx } from "../../context/userContext"

export default function DirectLinkRouterPage() {
  const navigate = useNavigate()
  const location = useLocation()

  const { pathname } = location.state || {}
  const state = location.state

  const { user } = React.useContext(UserCtx)
  const { showAuthModal, setShowAuthModal } = React.useContext(CommonFunctionCtx)
  const [isFirstRenderComplete, setIsFirstRenderComplete] =
    React.useState<boolean>(false)

  const authenticatedUser = useAuthenticatedUser(user)

  React.useEffect(() => {
    if (!authenticatedUser && !showAuthModal && isFirstRenderComplete) {
      navigate("/")
    }
  }, [showAuthModal])

  React.useEffect(() => {
    if (!authenticatedUser) {
      setShowAuthModal(true)
      localStorage.removeItem("user")
    } else {
      if (pathname) {
        navigate(pathname)
      } else {
        user?.isCoach ? navigate("/coach") : navigate("/member")
      }
    }
    setIsFirstRenderComplete(true)
  }, [])

  return (
    <div>
      <AnimatePresence>
        {showAuthModal && (
          <div className="fixed top-[20%] left-0 right-0 mx-auto">
            <AuthModal
              successRedirectPathname={state.pathname || null}
              successRedirectSearchParams={state.searchParams || null}
              preRedirectActions={state.actions || null}
            />
          </div>
        )}
      </AnimatePresence>
    </div>
  )
}
